import { Quaternion, Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { WorldTransform } from "./WorldTransform";
import { Animation } from "@babylonjs/core/Animations/animation.js";
const CHECK_CAMERA_POSITION_MS = 250;
const MAX_DISTANCE_SQUARED = 0.3 * 0.3;
const ANIMATION_DURATION_S = 0.5;
export class WorldTransform6dof extends WorldTransform {
    constructor(params) {
        super(params);
        this._isMoving = false;
        this._changePose6dof({ useAnimation: false });
        setInterval(() => {
            this._changePose6dof({ useAnimation: true });
        }, CHECK_CAMERA_POSITION_MS);
    }
    _changePose6dof(params) {
        if (this._isMoving)
            return;
        const camera = this._scene.activeCamera;
        if (!camera) {
            return;
        }
        const cameraPosition = camera.position;
        const newPosition = new Vector3(cameraPosition.x, cameraPosition.y, cameraPosition.z);
        if (!params.useAnimation) {
            this._moveWorld(newPosition);
            return;
        }
        const distanceSquared = newPosition.subtract(this._currentPosition).lengthSquared();
        if (distanceSquared < MAX_DISTANCE_SQUARED) {
            return;
        }
        this._isMoving = true;
        const beginPos = this._currentPosition;
        const endPos = newPosition;
        const frameRate = 50;
        const keyFrames = [];
        keyFrames.push({
            frame: 0,
            value: beginPos
        });
        keyFrames.push({
            frame: frameRate * ANIMATION_DURATION_S,
            value: endPos
        });
        const animation = new Animation("slideVerticalAnimation", "position", frameRate, Animation.ANIMATIONTYPE_VECTOR3);
        animation.setKeys(keyFrames);
        this._scene.beginDirectAnimation(this._guiParentNode, [animation], 0, frameRate * ANIMATION_DURATION_S, false, 1, () => {
            this._moveWorld(endPos);
            this._isMoving = false;
        });
    }
    evaluateAndSetPose() {
        this._changePose6dof({ useAnimation: false });
    }
    recenter() {
        this._moveWorld(Vector3.Zero());
        const rot = (this._scene.activeCamera?.absoluteRotation ?? Quaternion.Identity()).toEulerAngles();
        rot.x = 0;
        rot.z = 0;
        this._guiParentNode.rotationQuaternion = rot.toQuaternion();
    }
}
